export default __webpack_public_path__ + "static/media/tablet-lumin.929a0372.jpg";